import { Injectable } from "@angular/core";
import { BehaviorSubject, Observer } from "rxjs";
import { ApiService } from "../services/api-service";
import { ApiServiceDelegate } from "../services/api-service-delegate";
import { ApiCollection } from "../services/api-collection";
import { AppCommon } from "../app-common";
import { NzMessageService } from "ng-zorro-antd/message";
import { DashboardComponent } from "src/app/pages/dashboard/dashboard.component";
import { MasterStatsModel } from "../models/dashboard.model";
import { TaskResponseModel } from "../models/task.model";
import { FeedbackFilterModel, FeedbackResponseModel } from "../models/feedback.model";
import { FeedbackStatsComponent } from "src/app/shared-components/feedback-stats/feedback-stats.component";

@Injectable({
    providedIn: "root",
})

export class DashboardViewModel {

    parentComponent: DashboardComponent;
    feedbackStatsComponent:FeedbackStatsComponent
    dashboardStatsResponseModel = new BehaviorSubject<MasterStatsModel>(new MasterStatsModel());
    tasksResponseModel = new BehaviorSubject<TaskResponseModel>(new TaskResponseModel());
    feedbackResponseModel = new BehaviorSubject<FeedbackResponseModel>(new FeedbackResponseModel());



    constructor(
        private apiService: ApiService,
        private message: NzMessageService
    ) {

    }
    subscribeToFeedbackStata(
        observerStatsResponseModel: Observer<MasterStatsModel>,
      ){
        this.dashboardStatsResponseModel.subscribe(observerStatsResponseModel);
      }

    subscribeToDashboard(
      observerStatsResponseModel: Observer<MasterStatsModel>,
      observerTasksResponseModel: Observer<TaskResponseModel>,
      observerFeedbacksResponseModel: Observer<FeedbackResponseModel>,
    ){
      this.dashboardStatsResponseModel.subscribe(observerStatsResponseModel);
      this.tasksResponseModel.subscribe(observerTasksResponseModel);
      this.feedbackResponseModel.subscribe(observerFeedbacksResponseModel);
    }

    getPayload(filters: FeedbackFilterModel){
        var str = '';
        
        if(filters?.app_name){
            str += "&application=" + filters.app_name
        }
        if(filters?.submitted_by){
            str += "&user_id=" + filters.submitted_by
        }
        if(filters?.assigned_to){
            str += "&assigned_to=" + filters.assigned_to
        }   
        if(filters?.type){
            str += "&task_type=" + filters.type
        } 
        if(filters?.title){
            str += "&title=" + filters.title
        } 
        if(filters?.status){
            str += "&status=" + filters.status
        }
        return str
    }

    getDashboardStats(id, filter?){
        let str =  '?page='+1 + '&page_size=10000' + this.getPayload(filter)
        // if(id){
        //     str += '&user_id='+ id
        // }
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.TASK_STATS + str ,
            Success: (e: any) => {
                this.dashboardStatsResponseModel.next(e);
                this.feedbackStatsComponent.dashboardStartsReceived();
                return e;
            },
            Error: (e: String) => {
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getTasks(){
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.TASK + '?is_completed=false'+ '?page='+1 + '&page_size=1000',
            Success: (e: any) => {
                this.tasksResponseModel.next(e);
                this.parentComponent.tasksReceived()
                return e;
            },
            Error: (e: String) => {
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getFeedbacks(){
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.FEEDBACK +  '?page='+1 + '&page_size=1000',
            Success: (e: any) => {
                this.feedbackResponseModel.next(e);
                return e;
            },
            Error: (e: String) => {
                return e;
            },
        };
        this.apiService.callService(d);
    }

    updateTask(id, data){
        let d: ApiServiceDelegate = {
            Data: data,
            Method: "PATCH",
            Action: ApiCollection.TASK + '/' + String(id),
            Success: (e: any) => {
                this.parentComponent.taskUpdated(id);
                this.message.success("Task updated", {nzDuration: 1000});
                return e;
            },
            Error: (e: String) => {
                this.message.error("Error while updating task", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }



}
